<template>
  <div class="filter_page" @click="companyNameOptionShow = false">
    <div class="top-bg"></div>
    <div class="top-title">
      <div>
        <span>智能匹配</span>
        <span>填写企业信息，获取产品推荐</span>
      </div>
      <div>
        <img
          src="https://static.xchengtech.cn/5927dc560b8048dc87ede7a09c175670.png"
          alt=""
        />
      </div>
    </div>
    <div class="infoBox">
      <div class="qy_info">
        <div class="filter_title">
          <div>①</div>
          <div>申请人信息</div>
        </div>
        <van-field
          type="digit"
          input-align="right"
          v-model="query.age"
          label="年龄"
          clearable
          placeholder="必填"
        >
          <template #extra>
            <div class="unit">岁</div>
          </template>
        </van-field>
        <van-field
          input-align="right"
          v-model="query.applyIdentity"
          label="借款人身份"
          placeholder="必填"
          :readonly="true"
          right-icon="arrow"
          @click="select('applyIdentity')"
        />
        <van-field
          input-align="right"
          v-model="query.legalPersonText"
          v-show="showlegalPerson"
          label="法人是否变更"
          :readonly="true"
          right-icon="arrow"
          @click="select('legalPerson')"
          clearable
        />
        <van-field
          input-align="right"
          v-model="query.stockPersonText"
          v-show="showStockPerson"
          label="股东是否变更"
          :readonly="true"
          right-icon="arrow"
          @click="select('stockPerson')"
          clearable
        />
        <van-field
          label-width="28vw"
          input-align="right"
          v-model="query.legalPersonMonth"
          label="法人变更时间"
          v-show="showLegalPersonMonth"
          :readonly="true"
          @click="select('legalPersonMonth')"
          clearable
        >
          <template #extra>
            <div class="unit">月</div>
          </template>
        </van-field>
        <van-field
          label-width="28vw"
          input-align="right"
          v-model="query.stockPersonMonth"
          label="股东变更时间"
          v-show="showStockPersonMonth"
          :readonly="true"
          @click="select('stockPersonMonth')"
          clearable
        >
          <template #extra>
            <div class="unit">月</div>
          </template>
        </van-field>

        <van-field
          label-width="28vw"
          input-align="right"
          v-model="query.legalPersonStockPercent"
          label="法人占股比例"
          type="digit"
          v-show="showLegalPersonStockPercent"
          clearable
        >
          <template #extra>
            <div class="unit">%</div>
          </template>
        </van-field>
        <van-field
          label-width="28vw"
          input-align="right"
          v-model="query.stockPersonStockPercent"
          label="股东占股比例"
          type="digit"
          v-show="showStockPersonStockPercent"
          clearable
        >
          <template #extra>
            <div class="unit">%</div>
          </template>
        </van-field>
        <van-field
          input-align="right"
          v-model="query.maxStockFlagText"
          label="是否最大股东"
          @click="select('maxStockFlag')"
          :readonly="true"
          right-icon="arrow"
          clearable
          v-show="mustSelectMaxStockFlag"
        />
        <van-field
          label-width="28vw"
          input-align="right"
          v-model="query.generalTaxpayerFlagText"
          label="是否一般纳税人"
          right-icon="arrow"
          :readonly="true"
          @click="select('generalTaxpayerFlag')"
          clearable
        />
      </div>

      <div class="qy_info">
        <div class="filter_title">
          <div>②</div>
          <div>企业信息</div>
        </div>
        <div class="companyNameOptionBox">
          <van-field
            input-align="right"
            class="companyName"
            @input="onCompanyNameChange"
            @clear="clearCompanyName"
            v-model="query.companyName"
            placeholder="必填"
            label="企业名称"
            clearable
          >
          </van-field>
          <div class="companyNameOption" v-show="companyNameOptionShow">
            <span
              @click="changeCompanyName(item)"
              v-for="(item, index) in companyNameOption"
              :key="index"
              >{{ item }}</span
            >
          </div>
        </div>

        <van-field
          input-align="right"
          right-icon="arrow"
          v-model="query.cityName"
          label="城市"
          :readonly="true"
          @click="selectArea = !selectArea"
          clearable
        />

        <van-field
          label-width="28vw"
          type="digit"
          input-align="right"
          v-model="query.companyAge"
          placeholder="必填"
          label="企业年限"
          clearable
        >
          <template #extra>
            <div class="unit">月</div>
          </template>
        </van-field>

        <!-- <van-field
          
          input-align="right"
          v-model="query.repaymentType"
          label="还款方式"
          placeholder="选择"
          
          right-icon="arrow"
          :readonly="true"
          @click="select('repaymentType')"
        /> -->
      </div>

      <div class="qy_info">
        <div class="filter_title">
          <div>③</div>
          <div>纳税信息</div>
        </div>
        <van-field
          label-width="28vw"
          input-align="right"
          v-model="query.invoiceSum"
          label="近一年开票总额"
          placeholder="必填"
          type="digit"
          clearable
        >
          <template #extra>
            <div class="unit">万</div>
          </template>
        </van-field>
        <van-field
          label-width="28vw"
          input-align="right"
          v-model="query.invoiceInterrupt"
          label="近一年断票月数"
          type="digit"
          clearable
        >
          <template #extra>
            <div class="unit">月</div>
          </template>
        </van-field>

        <van-field
          input-align="right"
          v-model="query.taxLevel"
          label="纳税评级"
          right-icon="arrow"
          @click="select('taxLevel')"
          :readonly="true"
          clearable
        />
        <van-field
          label-width="28vw"
          input-align="right"
          v-model="query.taxSum"
          label="近一年纳税额"
          type="digit"
          clearable
        >
          <template #extra>
            <div class="unit">万</div>
          </template>
        </van-field>
        <van-field
          input-align="right"
          v-model="query.oweTaxFlagText"
          label="是否欠税"
          right-icon="arrow"
          :readonly="true"
          @click="select('oweTaxFlag')"
          clearable
        />
      </div>

      <div class="filter_button" @click="submit">
        <span> 开始筛选 </span>
      </div>
    </div>

    <van-popup position="bottom" value-key="value" v-model="showSelect">
      <van-picker
        title="请选择"
        show-toolbar
        :columns="columns"
        @confirm="onConfirm"
        @cancel="showSelect = !showSelect"
      />
    </van-popup>
    <van-popup v-model="selectArea" position="bottom">
      <van-area
        :columns-num="2"
        title="选择地区"
        :area-list="areaList"
        @confirm="confirmArea"
        @cancel="selectArea = !selectArea"
      />
    </van-popup>
    <van-popup v-model="result" position="bottom">
      <productList :pl="resultPl"></productList>
    </van-popup>
  </div>
</template>

<script>
import { areaList } from "@vant/area-data";
import Vue from "vue";
import { Field, Popup, Picker, Area, Toast } from "vant";
import { productFilter } from "@/api/product";
import { xcCompanySearch } from "@/api/xcCustomer";
import productList from "./module/productList";
Vue.use(Field);
Vue.use(Popup);
Vue.use(Picker);
Vue.use(Area);
Vue.use(Toast);
export default {
  components: {
    productList,
  },
  mounted() {},
  created() {
    this.handleAreaList();
  },
  data() {
    return {
      resultPl: [],
      result: false,
      areaList: areaList,
      selectArea: false,
      selectKey: "",
      showSelect: false,
      query: {},
      columns: [],
      option: {
        applyIdentity: ["法人", "股东"],
        legalPerson: [
          { text: "是", value: true },
          { text: "否", value: null },
        ],
        repaymentType: ["先息后本", "等额本金", "等额本息"],
        taxLevel: ["A", "B", "C", "D", "M", "无评级"],
        oweTaxFlag: [
          { text: "是", value: true },
          { text: "否", value: false },
        ],
        generalTaxpayerFlag: [
          { text: "是", value: true },
          { text: "否", value: false },
        ],
        maxStockFlag: [
          { text: "是", value: true },
          { text: "否", value: false },
        ],
        stockPerson: [
          { text: "是", value: true },
          { text: "否", value: null },
        ],
        legalPersonMonth: [0, 1, 3, 6, 8, 12],
        stockPersonMonth: [0, 1, 3, 6, 8, 12],
      },
      showLegalPersonMonth: false,
      showStockPersonStockPercent: false,
      showLegalPersonStockPercent: false,
      mustSelectMaxStockFlag: false,
      showStockPersonMonth: false,
      showStockPerson: false,
      showlegalPerson: false,
      companyNameOption: [],
      companyNameOptionShow: false,
    };
  },
  methods: {
    select(key) {
      console.log("key", key);
      this.columns = this.option[key];
      this.selectKey = key;
      this.showSelect = true;
    },

    onConfirm(event) {
      this.showSelect = false;
      switch (this.selectKey) {
        case "oweTaxFlag":
          this.query.oweTaxFlagText = event.text;
          this.query.oweTaxFlag = event.value;
          break;
        case "generalTaxpayerFlag":
          this.query.generalTaxpayerFlagText = event.text;
          this.query.generalTaxpayerFlag = event.value;
          break;
        case "applyIdentity":
          if (event == "法人") {
            this.showLegalPersonStockPercent = true;
            this.showStockPersonStockPercent = false;
            this.mustSelectMaxStockFlag = false;
            this.showlegalPerson = true;
            this.showStockPerson = false;
          }
          if (event == "股东") {
            this.showStockPersonStockPercent = true;
            this.showLegalPersonStockPercent = false;
            //2022年5月7日16:44:42 003 需求 是否最大股东改为非必填
            //2022年5月10日09:31:11 改回去
            this.mustSelectMaxStockFlag = true;
            this.showStockPerson = true;
            this.showlegalPerson = false;
          }
          this.query[this.selectKey] = event;
          break;
        case "maxStockFlag":
          console.log("event :>> ", event);
          this.query.maxStockFlag = event.value;
          this.query.maxStockFlagText = event.text;
          console.log("maxStockFlag :>> ", this.query);
          break;
        case "legalPerson":
          this.query.legalPersonText = event.text;
          this.query.legalPerson = event.value;
          if (event.text == "是") {
            this.showLegalPersonMonth = true;
          } else {
            this.showLegalPersonMonth = false;
          }
          break;
        case "stockPerson":
          this.query.stockPersonText = event.text;
          this.query.stockPerson = event.value;
          if (event.text == "是") {
            this.showStockPersonMonth = true;
          } else {
            this.showStockPersonMonth = false;
          }
          break;
        default:
          this.query[this.selectKey] = event;
      }
    },
    submit() {
      //年龄必填
      if (!this.query.age) {
        Toast("请输入年龄");
        return;
      }
      //借款人身份必填
      if (!this.query.applyIdentity) {
        Toast("请选择借款人身份");
        return;
      }
      //是否最大股东必填
      if (this.mustSelectMaxStockFlag) {
        if (!this.query.maxStockFlagText) {
          Toast("请选择是否最大股东");
          return;
        }
      }
      //企业名称必填
      if (!this.query.companyName) {
        Toast("请输入企业名称");
        return;
      }
      //城市必选
      // if (!this.query.cityCode) {
      //     Toast("请选择城市");
      //     return;
      // }
      //企业年限必选
      if (!this.query.companyAge) {
        Toast("请选择企业年限");
        return;
      }
      //开票总额必选
      if (!this.query.invoiceSum) {
        Toast("请选择开票总额");
        return;
      }

      this.query.age1 = this.query.age;
      this.query.age2 = this.query.age;
      // 企业名称去空格
      this.query.companyName = this.query.companyName.replace(/\s+/g, "");
      //去掉空值
      for (let key in this.query) {
        console.log("key :>> ", this.query[key]);
        if (this.query[key] === null || this.query[key] === "") {
          console.log(key);
          delete this.query[key];
        }
      }
      Toast.loading({
        message: "产品匹配中...",
        forbidClick: true,
        mask: true,
        duration: 0,
      });

      productFilter(this.query)
        .then((res) => {
          Toast.clear();
          console.log("res", res);
          // res = res.filter((item) => {
          //     if (item.status == "up") {
          //         return item;
          //     }
          // });
          this.resultPl = res.sort((a, b) => a.sort - b.sort);
          // 传值给vue页面 用于大后台的生成报告
          window.parent.postMessage(
            { queryMsg: this.query, result: this.resultPl },
            "*"
          );
          this.result = true;
        })
        .catch((err) => {
          Toast.clear();
        });
    },
    handleAreaList() {
      delete areaList.province_list["810000"];
      delete areaList.province_list["710000"];
      delete areaList.province_list["820000"];
    },
    confirmArea(e) {
      this.query.cityCode = e[1].code;
      this.query.cityName = e[0].name + "/" + e[1].name;
      this.selectArea = false;
    },
    onCompanyNameChange(e) {
      // 例如：珠海市香
      if (e.length > 3) {
        xcCompanySearch(e).then((res) => {
          if (res && res[0]) {
            this.companyNameOption = res;
            this.companyNameOptionShow = true;
          }
        });
      }
    },
    changeCompanyName(e) {
      this.query.companyName = e;
      this.companyNameOptionShow = false;
    },
    clearCompanyName() {
      this.companyNameOptionShow = false;
      this.companyNameOption = [];
    },
  },
};
</script>
<style scoped src="./index.css"></style>



// WEBPACK FOOTER //
// src/view/productFilter/index.vue